<template>
  <SoWidget :loading="loading" filled class="h-auto mb-4">
    <button
      class="so-info-box w-100"
      tabindex="0"
      aria-label="open info box"
      @click="toggleInfoBox()"
    >
      <div class="font-weight-medium d-flex gap-2 align-center pa-2 text-left">
        <SoIcon v-if="icon" :icon="icon" class="align-self-start" />
        {{ title }}
        <v-spacer />
        <SoIcon :icon="isOpen ? 'chevron-up' : 'chevron-down'" />
      </div>
    </button>
    <v-expand-transition>
      <div v-show="isOpen" class="mx-2" data-testid="so-info-box-content">
        <section v-if="!loading" class="py-2">
          <slot></slot>
        </section>
        <SoSkeleton v-else height="100" />
      </div>
    </v-expand-transition>
  </SoWidget>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoIcon from "@/components/SoIcon.vue"
  import SoWidget from "@/components/SoWidget.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import { IconStringWithModifiers } from "@/types/Icon"

  export default defineComponent({
    components: {
      SoIcon,
      SoWidget,
      SoSkeleton,
    },
    props: {
      title: {
        type: String,
        default: "",
        required: true,
      },
      icon: {
        type: String as PropType<IconStringWithModifiers>,
        default: "",
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isOpen: true,
      }
    },
    mounted() {
      if (this.$vuetify.display.mobile) {
        this.isOpen = false
      }
    },
    methods: {
      toggleInfoBox() {
        this.isOpen = !this.isOpen
      },
    },
  })
</script>
<style scoped>
  .so-info-box {
    cursor: pointer;
  }
  .so-info-box:focus-visible {
    outline: var(--theme-outline);
    border-radius: var(--theme-radius);
  }
</style>
